import script from "./ClassicAdminLoginStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicAdminLoginStep.vue?vue&type=script&setup=true&lang=js"

import "./ClassicAdminLoginStep.vue?vue&type=style&index=0&id=246eec52&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/keepyoursight/keepyoursight/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246eec52"]])

export default __exports__